import { render, staticRenderFns } from "./ProtectionScheme.vue?vue&type=template&id=12c23ca0&scoped=true"
import script from "./ProtectionScheme.vue?vue&type=script&lang=js"
export * from "./ProtectionScheme.vue?vue&type=script&lang=js"
import style0 from "./ProtectionScheme.vue?vue&type=style&index=0&id=12c23ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c23ca0",
  null
  
)

export default component.exports